import ReactJsonSyntaxHighlighter from './ReactJsonSyntaxHighlighter.react'

export default ReactJsonSyntaxHighlighter



// WEBPACK FOOTER //
// ./src/main/index.js